import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["useSelector", "useDispatch", "query"];
import * as React from 'react';
import { Help } from '../../components/Help';
import { useReferenceUrl } from './useReferenceUrl';
export var HelpContainer = function HelpContainer(_ref) {
  var useSelector = _ref.useSelector,
    useDispatch = _ref.useDispatch,
    query = _ref.query,
    helpComponentProps = _objectWithoutProperties(_ref, _excluded);
  var refUrl = useReferenceUrl({
    useSelector: useSelector,
    useDispatch: useDispatch
  });
  var queryString = React.useMemo(function () {
    var queryParams = new URLSearchParams(query);
    if (refUrl) {
      queryParams.append('ref', refUrl);
    }
    return queryParams.toString();
  }, [query, refUrl]);
  return /*#__PURE__*/React.createElement(Help, _extends({}, helpComponentProps, {
    query: queryString
  }));
};